//import Glide from '././node_modules/@glidejs/glide'



const initialiseSliders = () => {
	document.querySelectorAll(".magazine-issue__glide").forEach((slider) => {
		if (!slider.getAttribute("data-initialized")) {
			new Glide(slider, {
				type: 'slider',
				startAt: 0,
				perView: 2,
				swipeThreshold: false, 
				dragThreshold: false,
				breakpoints: {
					641: {
						type: 'carousel',
						perView: 1,
						peek: {
							before: 0,
							after: 0,
						  },
						swipeThreshold: true, 
						dragThreshold: true,
					},
				},
			}).mount();
			slider.setAttribute("data-initialized", "true");
		}
	});
};

const onDocumentReady = (callback) => {
	document.readyState !== "loading" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};

onDocumentReady(initialiseSliders);
